__turbopack_context__.v({
  "className": "cormorant_garamond_6a60505e-module__X0p7mW__className",
});
